import React, { useMemo, useRef } from 'react';
import styles from './course-list.module.scss';
import { SelectOption } from '../../../../types';

type Props = {
  label: string;
  renderLabel?: (labelComponent: React.ReactNode) => React.ReactNode;
  options: SelectOption[];
  disabled?: boolean;
  value: string[];
  className?: string;
  inline?: boolean;
  subTitle?: string;
  error?: boolean;
  showSearch?: boolean;
  searchAutoFocus?: boolean;
};

function CourseList(props: Props) {
  const {
    className,
    label,
    options = [],
    value,
    subTitle,
    disabled,
    renderLabel,
    inline,
    error,
  } = props;
  const wrapperRef = useRef<HTMLDivElement>(null);

  const wrapperClasses = useMemo(() => {
    const classes = [styles.wrapper, styles.opened, className];
    if (value) {
      classes.push(styles.minheight);
    }
    if (inline) {
      classes.push(styles.inline);
    }
    if (error) {
      classes.push(styles.error);
    }
    if (disabled) {
      classes.push(styles.disabled);
    }
    return classes.join(' ').trim();
  }, [className, disabled, inline, error, value]);

  const sorted = useMemo(() => {
    if (!options) return [];
    return [...options].sort((a, b) => a.label.localeCompare(b.label));
  }, [options]);

  return (
    <div className={wrapperClasses} ref={wrapperRef}>
      <div className={styles.header}>
        {typeof renderLabel === 'function' ? renderLabel(<div className={styles.headerLabel}>{label}</div>) :
          <div className={styles.headerLabel}>{label}</div>}
      </div>
      <div className={styles.selectWrapper}>
        <ul className={styles.list}>
          {sorted.length ?
            sorted.map(o => {
              const selected = (value as any[]).find((c) => o.value === c);
              return ( 
                selected ?
                <li key={o.value} className={styles.listItem}>
                  {o.label}
                </li> : null
              )
            })
            : <li className={styles.listItem}>No options</li>
          }
        </ul>
        {subTitle && <div className={styles.subtitle}>{subTitle}</div>}
      </div>
    </div>
  );
}

export default CourseList;
